<template>
  <layout-page is-not-scrollable hide-copyright>
    <div class="user_dashboard">
      <div class="column_one">
        <h2 class="user_dashboard--heading">{{ userFirstName }}'s Dashboard</h2>

        <div class="box column_one--top">
          <user-dashboard-notifications-box/>
        </div>
        <div class="box column_one--bottom">
          <user-dashboard-appointments-box/>
        </div>
      </div>
      <div class="column_two">
        <div class="box">
          <user-dashboard-leads-box/>
        </div>
      </div>
      <div class="column_three">
        <template v-for="(message, index) in messages">
          <div class="box" :key="index">
            <div class="dashboard_ad" v-if="message.image_url">
              <a :href="message.link" target="_blank">
                <img :src="message.image_url" :alt="message.image_alt_text">
              </a>
            </div>

            <div class="md-block" v-if="message.message">
              <md-block>
                {{ message.message }}
              </md-block>
            </div>
          </div>
        </template>
      </div>
    </div>
  </layout-page>
</template>

<script>
import UserDashboardNotificationsBox from "./components/UserDashboardNotificationsBox";
import UserDashboardAppointmentsBox from "./components/UserDashboardAppointmentsBox";
import UserDashboardLeadsBox from "./components/UserDashboardLeadsBox";

export default {
  name: "UserDashboardPage",
  components: {UserDashboardLeadsBox, UserDashboardAppointmentsBox, UserDashboardNotificationsBox},
  created() {
    this.$store.dispatch("dashboard/setup").then(() => {});
  },
  destroyed() {
    this.$store.dispatch("dashboard/tearDown");
  },
  computed: {
    messages() {
      return this.$store.state.dashboard.messages;
    },
    userFirstName() {
      return this.$store.getters.authUser.first_name;
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../styles/variables/variables";

$column1Width: 320px;
$headingFontSize: 18px;
$headingHeight: 28px;
$column1TopBoxHeight: 100px;
$column1TopBoxHeight: 125px;
$column3Width: 360px;

.user_dashboard {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;

  &--heading {
    font-size: $headingFontSize;
    font-weight: bold;
    color: $text-muted;
    line-height: $headingFontSize;
  }
}

.column_one {
  position: absolute;
  top: $pagePaddingVertical;
  bottom: $pagePaddingVertical;
  left: $pagePaddingHorizontal;
  width: $column1Width; // min necessary for width of calendar

  &--top {
    position: absolute;
    top: $headingHeight;
    left: 0;
    right: 0;
    height: $column1TopBoxHeight;
  }

  &--bottom {
    position: absolute;
    top: $headingHeight + $column1TopBoxHeight + $pagePaddingVertical;
    left: 0;
    right: 0;
    bottom: 0;
  }
}

.column_two {
  position: absolute;
  top: $pagePaddingVertical;
  bottom: $pagePaddingVertical;
  left: $column1Width + ($pagePaddingVertical + $pagePaddingHorizontal);
  right: $column3Width + ($pagePaddingVertical + $pagePaddingHorizontal);

  .box {
    position: relative;
    height: 100%;
  }
}

.column_three {
  position: absolute;
  top: $pagePaddingVertical;
  bottom: $pagePaddingVertical;
  right: $pagePaddingHorizontal;
  width: $column3Width;

  .box {
    position: relative;
    margin-bottom: 1rem;

    &:last-child {
      margin-bottom: 0;
    }
  }
}

.box {
  padding: 0;
  color: $text;
}

.dashboard_ad {
  width: 360px;
  height: 160px;
  margin-bottom: 1rem;
  overflow: hidden;
}

:deep(.md-block) {
  padding: 0 .75rem .75rem;

  * {
    margin: 0;
    padding: 0;
    font-size: 15px;
    font-weight: 400;
    line-height: 1.4;
    color: $dark-grey;
  }

  h1, h2, h3, h4, h5, h6, ul, ol, p, table, img {
    margin-bottom: .75rem;
    &:last-child { margin-bottom: 0; }
  }

  strong { font-weight: bold; }

  h1 { font-size: 26px; }
  h2 { font-size: 24px; }
  h3 { font-size: 22px; }
  h4 { font-size: 20px; }
  h5 { font-size: 18px; }
  h6 { font-size: 16px; }

  ul { list-style: disc inside; }
  ol { list-style: decimal inside; }
  li {
    &::marker {
      unicode-bidi: isolate;
      font-variant-numeric: tabular-nums;
      text-transform: none;
      text-indent: 0;
      text-align: start;
      text-align-last: start;
    }
  }
}
</style>
